import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isLoading: false,
  message: "Loading...",
  messages: [],
  keys: [],
  chartsBucketsIsLoading: false
}

const slice = createSlice({
  name: 'exploreLoadingSlice',
  initialState,
  reducers: {
    setExploreIsLoading: {
      reducer: (state, action) => {
        const { keys, messages } = state;
        const { payload } = action;
        const loadingIndex = state.keys.indexOf(payload.key);
        if (payload.isLoading) {
          if (loadingIndex > -1) {
            keys[loadingIndex] = payload.key;
            messages[loadingIndex] = payload.message;
          } else {
            keys.push(payload.key);
            messages.push(payload.message);
          }
        } else {
          if (loadingIndex > -1) {
            keys.splice(loadingIndex, 1);
            messages.splice(loadingIndex, 1);
          }
        }
        state.isLoading = messages.length > 0;
        state.message = messages[0] ?? '';
      },
      prepare: (isLoading, key, message = '') => ({ payload: { isLoading, key, message }})
    },
    setExploreChartsBucketsIsLoading: (state, action) => {
      state.chartsBucketsIsLoading = action.payload;
    }
  }
});

export const exploreLoadingActions = slice.actions;
export default slice.reducer;